// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_hdQ","cls2":"ImpactHubModal-cls2_kcz ImpactHubModal-cls1_hdQ"};